// import assign from 'lodash/assign';
import * as actionTypes from '../constants/actionTypes';
import {ActionTypes as customerActionTypes} from '../actions/customers.js';
import _ from 'lodash';
// import * as editorNames from '../constants/editorNames';

const initialState = {
  transientFeatures: [],
  transientFeatureGroups: [],
  masterFeatures: [],
  masterFeatureGroups: [],
  activeFeatureGroupName: '',
  loaded: false
};

function setFeatures(state, action) {
  const { transientFeatures, transientFeatureGroups } = action.payload;
  return { ...state, transientFeatures, transientFeatureGroups, loaded: true };
}

function setMasterFeatures(state, action) {
  const { masterFeatures, masterFeatureGroups } = action.payload;
  _.each(masterFeatures, function(feature) {
    feature.enabled = false;
  });
  
  _.each(masterFeatureGroups, function(group) {
    group.enabled = false;
  });
  return { ...state, masterFeatures, masterFeatureGroups };
}

/* TODO: Marcus@HV: Repurpose this for committing transient state.
function updateTransientFeatureField(state, action) {
  const { item, key, value } = action.payload;
  const transientFeatures = state.transientFeatures.map(f =>
    ((item.id === f.id) ? assign({}, f, { [key]: value }) : f)
  );

  return { ...state, transientFeatures };
}

function updateTransientFeatureGroupField(state, action) {
  const { item, key, value } = action.payload;
  const transientFeatureGroups = state.transientFeatureGroups.map(fg =>
    ((item.name === fg.name) ? assign({}, fg, { [key]: value }) : fg)
  );
  return { ...state, transientFeatureGroups };
}
*/

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_FEATURES:
      let feat = setFeatures(state, action);
      return feat;
    case actionTypes.SET_MASTER_FEATURES:
      return setMasterFeatures(state, action);

    case actionTypes.SET_ACTIVE_FEATURE_GROUP_NAME:
      return { ...state, activeFeatureGroupName: action.name };

    case customerActionTypes.APP_SET_AS_CUSTOMER:
      return {...initialState};

    default:
      return state;
  }
}
